export default __webpack_public_path__ + "static/media/Logo_Manthano_GmbH_HTML.634ef65f.svg";